module.exports = __webpack_public_path__ + "img/thumb_finance.6e36972c.jpg";